import { useHistory } from 'react-router-dom';
import { useAppDispatch } from '../../../../services/store';
import { moveMapToSignalsPosition } from '../../../../services/store/modules/signal';
import { captureEvent } from '../../../../services/event-capture';

const useSignalUtilities = () => {
  const history = useHistory();
  const navigateToSignal = (id: string) => {
    captureEvent({
      type: 'signal: navigate to signal',
      payload: {
        signalId: id,
      },
      sendToAmplitude: true,
    });
    history.push(`/maps/signal/${id}`);
  };

  const dispatch = useAppDispatch();

  const centerMapOnSignal = async (
    id: string,
    ref?: { clientHeight: number; clientWidth: number } | null,
  ) => {
    captureEvent({
      type: 'signal: center map on signal',
      payload: {
        signalId: id,
      },
      sendToAmplitude: true,
    });

    const client = ref || { clientHeight: 0, clientWidth: 0 };
    const sheetHeight = client.clientHeight;
    const sheetWidth = client.clientWidth;

    // Hard coded pixel size of when the app switches to mobile size
    const isMobile = (window.innerWidth || 0) <= 800;

    // For desktop, offset a little to the right
    // For mobile, offset towards the top

    dispatch(
      moveMapToSignalsPosition({
        id,
        offsetY: isMobile ? sheetHeight * 0.45 : 0,
        offsetX: !isMobile ? -sheetWidth * 0.45 : 0,
        jumpToLocation: true,
      }),
    );
  };

  return {
    navigateToSignal,
    centerMapOnSignal,
  };
};

export default useSignalUtilities;
